export default __webpack_public_path__ + "static/double_door_b.7af60c35f4d3f17bca7537e5f8b42ac6.svg";